<template>
  <div>
    <div id="Loadingbg" v-show="show">
      <div id="loading-bg" style="width: 100px; height: 100px">
        <img src="@/assets/images/loading.gif" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
// loading组件
export default {
  name: "loading",
  data() {
    return {
      notices: [],
      show: false,
      add_num: 0,
    };
  },
  methods: {
    add() {
      this.add_num++;
      this.show = true;
    },
    remove_notice() {
      // 删除对应loading
      this.add_num--;
      if (this.add_num <= 0) {
        this.show = false;
        this.add_num = 0;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#Loadingbg {
  position: fixed;
  z-index: 999999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  top: 0;
  #loading-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 200;
    text-align: center;
    overflow: hidden;
    margin-left: -50px;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }
}
@keyframes loading {
  0% {
    transform: translateY(0);
  }
  5% {
    transform: translateY(-5%);
  }
  10% {
    transform: translateY(-10%);
  }
  15% {
    transform: translateY(-15%);
  }
  20% {
    transform: translateY(-20%);
  }
  25% {
    transform: translateY(-25%);
  }
  30% {
    transform: translateY(-30%);
  }
  35% {
    transform: translateY(-35%);
  }
  40% {
    transform: translateY(-40%);
  }
  45% {
    transform: translateY(-45%);
  }
  50% {
    transform: translateY(-50%);
  }
  55% {
    transform: translateY(-55%);
  }
  60% {
    transform: translateY(-60%);
  }
  65% {
    transform: translateY(-65%);
  }
  70% {
    transform: translateY(-70%);
  }
  75% {
    transform: translateY(-75%);
  }
  80% {
    transform: translateY(-80%);
  }
  85% {
    transform: translateY(-85%);
  }
  90% {
    transform: translateY(-90%);
  }
  95% {
    transform: translateY(-95%);
  }
  100% {
    transform: translateY(-100%);
  }
}
</style>
